var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg004Server(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,105c0,24.8-20.2,45-45,45H45c-24.8,0-45-20.2-45-45V45C0,20.2,20.2,0,45,0h422c24.8,0,45,20.2,45,45V105 z M45,30c-8.3,0-15,6.7-15,15v60c0,8.3,6.7,15,15,15h422c8.3,0,15-6.7,15-15V45c0-8.3-6.7-15-15-15H45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75,
    cy: 75,
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 135,
    cy: 75,
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,286c0,24.8-20.2,45-45,45H45c-24.8,0-45-20.2-45-45v-60c0-24.8,20.2-45,45-45h422c24.8,0,45,20.2,45,45 V286z M45,211c-8.3,0-15,6.7-15,15v60c0,8.3,6.7,15,15,15h422c8.3,0,15-6.7,15-15v-60c0-8.3-6.7-15-15-15H45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437,271H317c-8.3,0-15-6.7-15-15s6.7-15,15-15h120c8.3,0,15,6.7,15,15C452,264.3,445.3,271,437,271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467,512H45c-24.8,0-45-20.2-45-45v-60c0-24.8,20.2-45,45-45h422c24.8,0,45,20.2,45,45v60 C512,491.8,491.8,512,467,512z M45,392c-8.3,0-15,6.7-15,15v60c0,8.3,6.7,15,15,15h422c8.3,0,15-6.7,15-15v-60c0-8.3-6.7-15-15-15 H45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75,
    cy: 437,
    r: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 135,
    cy: 437,
    r: 15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Server);
export default __webpack_public_path__ + "static/media/004-server.570256e2668e9e89ef2d43396834d465.svg";
export { ForwardRef as ReactComponent };